<template>
  <div class="product-preamble">
    <div class="block print:hidden">
      <span
        class="font-extrabold text-[28px] mb-0"
        :data-translation="trip?.title_translationkey"
      >
        <span
          v-if="trip.new_trip"
          class="text-medium-blue mr-2"
        >
          {{ $t('newTrip') }}
        </span>
        {{ trip.title }}
        <span class="hidden md:inline">
          {{ trip.daysText ? ', ' + trip.daysText : '' }}
        </span>
      </span>
      <span
        class="font-bold block my-3 font-secondary"
        :data-translation="trip?.subtitle_translationkey"
      >
        {{ ' – ' }} {{ trip.subtitle }}
      </span>
    </div>

    <div class="hidden print:block text-xl font-secondary">
      <strong>
        {{ trip.title }}

        <span v-if="trip.daysText">
          , {{ trip.daysText }}
        </span>
      </strong>
      <span v-if="trip.subtitle">
        – {{ trip.subtitle }}
      </span>
    </div>

    <div
      class="whitespace-pre-line font-secondary"
      :data-translation="trip?.preamble_translationkey"
      v-html="toUnixNewlines(trip.preamble)"
    />
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    trip: {
      type: Object,
      required: true,
    },
  },

  methods: {
    toUnixNewlines,
  },

})
</script>

<style lang="scss">
.product-preamble {
  h4 {
    @media (max-width: theme('screens.md')) {
      font-size: 1.5em;
    }
  }
}
</style>
